module.exports = __webpack_public_path__ + "static/media/leaderboard.8abcc1d6.png";